// Module
var code = "<p>If you are enrolled in our Paperless Billing, you will receive an email alerting you that you have mail in your Paperless Inbox</p> ";
// Exports
export default code;